// extracted by mini-css-extract-plugin
export default {"tooltip":"AS-z","arrow":"BS-z"};